export default __webpack_public_path__ + "static/media/Banner - EarBuddyz ULTRA - White.0c3099d4.jpg";